import type { FirebaseOptions } from 'firebase/app';
import { LOCAL_FIREBASE_CONFIG, parseEcoEnv, type EcoEnv } from '@ecobox/firebase';

const meta = import.meta.env;

export const ECOBOX_ENV: EcoEnv = parseEcoEnv(meta.VITE_ECOBOX_ENV);
export const APP_VERSION = `ops-${meta.VITE_APP_VERSION ?? '6.0.0-dev'}`;

function pick(value: unknown, fallback: string | undefined): string | undefined {
  return typeof value === 'string' && value !== '' ? value : fallback;
}

/** `VITE_FIREBASE_*` values, falling back to the local emulator project (`demo-ecobox`). */
export function firebaseConfig(): FirebaseOptions {
  const local = LOCAL_FIREBASE_CONFIG;
  const config: FirebaseOptions = {
    apiKey: pick(meta.VITE_FIREBASE_API_KEY, local.apiKey) ?? '',
    authDomain: pick(meta.VITE_FIREBASE_AUTH_DOMAIN, local.authDomain) ?? '',
    projectId: pick(meta.VITE_FIREBASE_PROJECT_ID, local.projectId) ?? '',
    appId: pick(meta.VITE_FIREBASE_APP_ID, local.appId) ?? '',
  };
  const bucket = pick(meta.VITE_FIREBASE_STORAGE_BUCKET, local.storageBucket);
  if (bucket) config.storageBucket = bucket;
  const sender = pick(meta.VITE_FIREBASE_MESSAGING_SENDER_ID, undefined);
  if (sender) config.messagingSenderId = sender;
  return config;
}
